<template>
    <div>
        <button class="btn-logout" @click="logout">Cerrar Sesión</button>
    </div>
</template>

<script>
    export default {
        name: 'Logout',
        computed: {
            isLoggedIn() {
                return this.$store.getters.isLoggedIn
            }
        },
        methods: {
            logout() {
                this.$swal({
                    type: 'warning',
                    title: 'Logout',
                    text: '¿Está seguro que desea salir?',
                    confirmButtonText: 'Si!',
                    showCancelButton: true,
                    cancelButtonColor: '#d33',
                    confirmButtonColor: '#3085d6',
                }).then(result => {
                    if (result.value) {
                        this.$swal('Logout', 'Sesión Cerrada Correctamente...', 'success')
                        this.$store.dispatch('logout')
                            .then(() => {
                                this.$router.push('/auth/login')
                            })
                    } else {
                        this.$swal('Cancelado...', '', 'error')
                    }
                })

            }
        }
    }
</script>

<style scoped>
    a {
        color: white;
        font-weight: bold;
    }

    .btn-logout {
        color: #8bff76;
        background: transparent;
        font-weight: bold;
        border-width: 0;
        outline: none;
    }
</style>
